import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { ConnectedEditDialogForm } from '@mews-commander/legacy-form';
import preferences from '../../../preferences';
import KeyCutterForm from './KeyCutterForm';
import { FormValues } from './types';

const {
    selectors: { getPreferredKeyCutterId },
} = preferences;

const keyCutterFormName = 'key-cutter-form';

interface OwnProps {
    reservationIds: string[];
    initKeyCount?: number;
    active: boolean;
    closeDialog: () => void;
    onSuccess: () => void;
}
interface StateProps {
    initialValues: Partial<FormValues>;
}
type Props = StateProps & OwnProps;

const KeyCutterDialog = ({ initialValues, active, closeDialog, onSuccess, reservationIds, initKeyCount }: Props) => (
    <ConnectedEditDialogForm
        formName={keyCutterFormName}
        active={active}
        primaryButtonTextKey={TextKey.CreateKey}
        closeDialog={closeDialog}
        title={<LocalizedText textKey={TextKey.CreateKeys} />}
    >
        <KeyCutterForm
            reservationIds={reservationIds}
            form={keyCutterFormName}
            initialValues={initialValues}
            showKeyCutterCount={!!initKeyCount}
            onSuccess={onSuccess}
        />
    </ConnectedEditDialogForm>
);

export default connect<StateProps, {}, OwnProps, ApplicationState>((state, { initKeyCount }) => {
    const preferredKeyCutterId = getPreferredKeyCutterId(state);
    return {
        initialValues: { keyCount: initKeyCount, keyCutter: preferredKeyCutterId },
    };
})(KeyCutterDialog);
